import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'products/list',
    name: 'manager-products-list',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductList.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/discounts',
    name: 'manager-products-discounts',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductsDiscounts.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/delivery-payment-text',
    name: 'manager-products-delivery-payment-text',
    component: () =>
      import(
        '../../../views/Manager/Products/ManagerProductsDeliveryPaymentText.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/angles',
    name: 'manager-products-angles',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductsAngles.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/you-may-like',
    name: 'manager-products-you-may-like',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductsYouMayLike.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/options',
    name: 'manager-products-options',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductsOptions.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/lenses-carousel',
    name: 'manager-products-lenses-carousel',
    component: () =>
      import(
        '../../../views/Manager/Products/ManagerProductsLensesCarousel.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/:id/general',
    name: 'manager-products-item-general',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/:id/properties',
    name: 'manager-products-item-properties',
    component: () =>
      import(
        '../../../views/Manager/Products/ManagerProductItemProperties.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/:id/other',
    name: 'manager-products-item-other',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductItemOther.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'products/:id/seo',
    name: 'manager-products-item-seo',
    component: () =>
      import('../../../views/Manager/Products/ManagerProductItemSeo.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
